<template>
    <div class='ratings-container'>
        <div id='product_rating' class="stars" :style='"--rating: "+ rating' :aria-label="'Rating of this product is '+rating+' out of 5.'"></div>
        <div v-show='number_of_reviews' class='number-of-reviews'>({{number_of_reviews}} Reviews)</div>
        <div v-show='number_of_reviews == 0' class='no-reviews'>No reviews</div>
    </div>
</template>

<script>
export default {
    props: ['rating', 'number_of_reviews'],
}

</script>

<style lang="scss" scoped>

.ratings-container{
    display: flex;
    gap: 10px;
    align-items: center;
}

.number-of-reviews{
    color: var(--black);
}

.no-reviews{
   color: var(--grey-1);
}

.stars {
    --star-size: 25px;
    --star-empty-colour: var(--grey-1);
    --star-colour: var(--black);
    --percent: calc(var(--rating) / 5 * 100%);
  
    display: inline-block;
    font-size: var(--star-size);
    font-family: Times;
    line-height: 1;
  
  &::before {
    content: '★★★★★';
    letter-spacing: 3px;
    background: linear-gradient(90deg, var(--star-colour) var(--percent), var(--star-empty-colour) var(--percent));
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}
</style>